import { __assign, __spreadArrays } from "tslib";
import { SortDirection } from './types';
var MultiSortManager = /** @class */ (function () {
    function MultiSortManager() {
        this._sortedColumns = [];
    }
    Object.defineProperty(MultiSortManager.prototype, "sortedColumns", {
        get: function () {
            return __spreadArrays(this._sortedColumns.map(function (c) { return (__assign({}, c)); }));
        },
        enumerable: true,
        configurable: true
    });
    MultiSortManager.prototype.addSortColumn = function (column) {
        this._sortedColumns.push(__assign({}, column));
        this._updateSortNumbers();
    };
    MultiSortManager.prototype.updateSortColumn = function (column) {
        var col = this._sortedColumns.find(function (c) { return c.columnIndex === column.columnIndex; });
        if (col) {
            switch (col.direction) {
                case SortDirection.Ascending:
                    this.removeSortColumn(column);
                    break;
                case SortDirection.Descending:
                    col.direction = SortDirection.Ascending;
                    break;
                case SortDirection.Unset:
                    col.direction = SortDirection.Descending;
                    break;
            }
        }
    };
    MultiSortManager.prototype.setSortColumns = function (columns) {
        this._sortedColumns = __spreadArrays(columns.map(function (c) { return (__assign({}, c)); }));
    };
    MultiSortManager.prototype.removeSortColumn = function (columnOrIndex) {
        if (typeof columnOrIndex === 'number') {
            this._sortedColumns.splice(columnOrIndex, 1);
        }
        else {
            this._sortedColumns.splice(this._sortedColumns.indexOf(columnOrIndex), 1);
        }
        this._updateSortNumbers();
    };
    MultiSortManager.prototype.isSortColumn = function (columnOrIndex) {
        if (typeof columnOrIndex === 'number') {
            return this._sortedColumns.some(function (c) { return c.columnIndex === columnOrIndex; });
        }
        else {
            return this._sortedColumns.includes(columnOrIndex);
        }
    };
    MultiSortManager.prototype.clearMultiSort = function () {
        this._sortedColumns = [];
    };
    MultiSortManager.prototype.getSortColumn = function (columnIndex) {
        return this._sortedColumns.find(function (c) { return c.columnIndex === columnIndex; });
    };
    MultiSortManager.prototype._updateSortNumbers = function () {
        // only do a real sort if every sortNumber is actually a number
        if (this._sortedColumns.every(function (c) { return typeof c.sortOrder === 'number'; })) {
            this._sortedColumns.sort(function (col1, col2) { return col1.sortOrder - col2.sortOrder; });
        }
        this._sortedColumns.forEach(function (column, index) { return column.sortOrder = index + 1; });
    };
    return MultiSortManager;
}());
export { MultiSortManager };
